import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type EmailSetting } from "features/Accounts/types";
import { getPrefix } from "features/Application/slices/models";

export interface ThreatDefenceSmtpSettingsState {
  settings: EmailSetting;
  isLoading: boolean;
  error: string | undefined;
  isVerifying: boolean;
  isVerified: boolean | undefined;
  verificationError: string | undefined;
}

const initialState: ThreatDefenceSmtpSettingsState = {
  settings: {
    id: undefined,
    isSsl: false,
    host: "",
    password: undefined,
    port: 0,
    senderEmail: "",
    senderName: "",
    userName: undefined,
    replyToEmail: "",
    accountId: 0,
  },
  isLoading: false,
  error: undefined,
  isVerifying: false,
  isVerified: undefined,
  verificationError: undefined,
};

export const editThreatDefenceSmtpSettingsSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.ThreatDefenceSmtpSettings,
    name: "edit",
  }),
  initialState,
  reducers: {
    req(state: ThreatDefenceSmtpSettingsState) {
      state.isLoading = true;
    },
    got(state: ThreatDefenceSmtpSettingsState, action: PayloadAction<EmailSetting | undefined>) {
      state.isLoading = false;
      state.settings = action.payload ?? initialState.settings;
    },
    err(state: ThreatDefenceSmtpSettingsState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    verifyReq(state: ThreatDefenceSmtpSettingsState) {
      state.isVerifying = true;
      state.isVerified = undefined;
      state.verificationError = undefined;
    },
    verifyGot(state: ThreatDefenceSmtpSettingsState) {
      state.isVerifying = false;
      state.isVerified = true;
    },
    verifyErr(state: ThreatDefenceSmtpSettingsState, action: PayloadAction<string>) {
      state.isVerifying = false;
      state.isVerified = false;
      state.verificationError = action.payload;
    },
    resetVerify(state: ThreatDefenceSmtpSettingsState) {
      state.isVerifying = false;
      state.isVerified = undefined;
      state.verificationError = undefined;
    },
  },
});

export const { req, got, err, verifyReq, verifyGot, verifyErr, resetVerify } =
  editThreatDefenceSmtpSettingsSlice.actions;

export default editThreatDefenceSmtpSettingsSlice.reducer;
